// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/includes
// includes is supported in all browsers but IE.

if (!Array.prototype.includes) {
    Array.prototype.includes = function (searchElement: any, fromIndex?: number): boolean {
        return this.indexOf(searchElement, fromIndex) >= 0;
    };
}
